import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  loading: 0,
  bundles: [],
  bundle: null
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
